import { useCallback, useContext } from 'react';
import { DashboardsContext } from '../contexts/DashboardsContext';
import { WorkspaceContext } from '../contexts/WorkspaceContext';
import { WorkspacesContext } from '../contexts/WorkspacesContext';
import { updateWorkspaceFunc } from '../lib/helper';
import { Workspace } from '../types/files';
import useBackwardsCompatible from './useBackwardsCompatible';

const useWorkspace = () => {
  const { setWorkspaces } = useContext(WorkspacesContext);
  const { setDashboards } = useContext(DashboardsContext);
  const { workspace, setWorkspace } = useContext(WorkspaceContext);
  const { dashboardWorkspaces } = useBackwardsCompatible();

  const sharePublicly = useCallback(async (sharing: boolean, localWorkspace?: Workspace) => {
    const updatedWorkspace = { ...(localWorkspace ?? workspace)!, isPublic: sharing };

    return new Promise((resolve, reject) => {
      updateWorkspaceFunc(updatedWorkspace)
        .then((updatedWorkspace?: Workspace) => {
          if (!!updatedWorkspace?.id) {
            setWorkspaces(prev => prev.map(ws =>
              ws.id === updatedWorkspace?.id ? {...updatedWorkspace} : ws
            ));
            if (!sharing) {
              setDashboards(prev => prev.map(dashboard => ({...dashboard,
                isPublic: dashboardWorkspaces(dashboard)?.includes(updatedWorkspace?.id) || dashboard.isPublic,
              })));
            }
            setWorkspace(updatedWorkspace);
            resolve(updatedWorkspace);
          } else {
            resolve(null);
          }
      }).catch(() => reject(null));
    });
  // eslint-disable-next-line
  }, [workspace]);

  return { sharePublicly };
};

export default useWorkspace;
